<template>
  <el-form-item
    :label="label"
    class="model-code"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="modelCd"
      :clearable="true"
      :maxlength="4"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '機種コード'
    },
    prop: {
      type: String,
      default: 'model_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角英数（最大4文字）'
    }
  },
  computed: {
    modelCd: {
      get () {
        return this.value
      },
      set (modelCd) {
        this.$emit('input', modelCd.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorHalfUCaseAlphabetNumber(this.label, 'blur'))
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-form--inline {
  .el-form-item {
    &.model-code {
      .el-form-item__content {
        width: 12em;
      }
    }
  }
}
</style>
